
export default {
  methods: {
    bottomVisible() {
      const scrollY = window.pageYOffset
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight - 58 // footer
      return bottomOfPage || pageHeight < visible
    },
    buttonFocus() {
      setTimeout(() => {
        const btn = this.$refs.btn
        if (btn) {
          btn.focus()
        }
      }, 100)
    } 
  }
}